// extracted by mini-css-extract-plugin
export default {"DrawerContent":"drawer-content_DrawerContent__Ksj1g"};